
export const formatNm = (nm) => {
    if (nm.length < 9) {
        return nm.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") 
    } else { 
        return nm
    }
  }
export const formatIppnFull = (ippn) => {
  if (ippn) {
    ippn = ippn.replace('A', '#')
    ippn = ippn.toString().replace(/^(\d{3})(\d{3})(\d{3})(\d{3})(\d{1})(.)(\d{3}).*/, '$1.$2.$3.$4-$5$6$7');
    if(ippn === 'Não Serializado')
      return ippn
    if(ippn.slice(ippn.length-4) === '#000'){
      ippn = ippn.slice(0,ippn.length-4);
    }else{
      ippn = `${ippn.slice(0,ippn.length-3)}${Number(ippn.slice(ippn.length-3))}`;
    }
  }
  return ippn
}